module.exports = __webpack_public_path__ + "img/icon-daftar-grey.4a46a75c.png";